export const navLinks = [
  {
    id: 'about',
    title: 'About Us',
    path: '/about',
  },
  {
    id: 'project-slot',
    title: 'Project Slot',
    path: '/project-slots',
  },
  {
    id: 'market',
    title: 'Real Estate Market',
    path: '/market',
  },
  {
    id: 'blog',
    title: 'Blog',
    path: '/blog',
  },
];
